import React from "react";
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import EighthFloor from "./floors/EighthFloor";
import NinthFloor from "./floors/NinthFloor";
import TenthFloor from "./floors/TenthFloor";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

const FloorPlan = ({
  scale,
  desktop,
  backgroundColor,
  eighthFloorRooms,
  ninthFloorRooms,
  tenthFloorRooms,
}) => {

  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route
        exact
        path={`${path}/8`}
        render={() => (
          <EighthFloor
            scale={scale}
            desktop={desktop}
            backgroundColor={backgroundColor}
            rooms={eighthFloorRooms}
          />
        )}
      />
      <Route
        exact
        path={`${path}/9`}
        render={() => (
          <NinthFloor
            scale={scale}
            desktop={desktop}
            backgroundColor={backgroundColor}
            rooms={ninthFloorRooms}
          />
        )}
      />
      <Route
        exact
        path={`${path}/10`}
        render={() => (
          <TenthFloor
            scale={scale}
            desktop={desktop}
            backgroundColor={backgroundColor}
            rooms={tenthFloorRooms}
          />
        )}
      />
      {path === '/floor' && <Redirect to={`${path}/8`} />}
    </Switch>
  );
};

export default FloorPlan;
